<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    iconPath="assets/icons/calendar-dots-light.svg"
    [title]="data.activity ? 'Aktivität bearbeiten' : 'Aktivität erstellen'"
  />

  <mat-dialog-content>
    <div class="flex flex-col gap-6 py-5">
      <div>
        <app-dropdown
          errorMsg="Eingabe erforderlich"
          label="Typ"
          [options]="activityTypeOptions"
          [control]="form.controls.type"
        />

        <app-input
          errorMsg="Eingabe erforderlich"
          type="text"
          label="Titel"
          [control]="form.controls.title"
        />

        <app-text-area
          label="Beschreibung"
          [control]="form.controls.description"
        />

        <app-input
          errorMsg="Eingabe erforderlich"
          type="date"
          label="Datum"
          [control]="form.controls.date"
        />

        <mat-checkbox
          class="example-margin text-base mb-2"
          [formControl]="form.controls.hasStartTime"
        >
          Startzeit festlegen
        </mat-checkbox>

        <app-input
          errorMsg="Eingabe erforderlich"
          type="time"
          label="Uhrzeit"
          [control]="form.controls.time"
        />
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div
      class="w-full grid grid-cols-2 gap-3"
      [class.grid-cols-2]="data.activity"
      [class.grid-cols-1]="!data.activity"
    >
      @if (requestState() === RequestStateEnum.ERROR) {
        <app-alert
          [type]="AlertTypeEnum.ERROR"
          [message]="alertMsg()"
        />
      }

      @if (!!data.activity) {
        <app-button
          variant="alert"
          text="Löschen"
          [disabled]="form.invalid"
          [isLoading]="requestState() === RequestStateEnum.PENDING"
          [fullWidth]="true"
          (clicked)="deleteActivity()"
        />

        <app-button
          text="Speichern"
          [disabled]="form.invalid || !form.dirty"
          [isLoading]="requestState() === RequestStateEnum.PENDING"
          [fullWidth]="true"
          (clicked)="updateActivity()"
        />
      } @else {
        <app-button
          text="Aktivität erstellen"
          [disabled]="form.invalid || !form.dirty"
          [isLoading]="requestState() === RequestStateEnum.PENDING"
          [fullWidth]="true"
          (clicked)="createActivity()"
        />
      }
    </div>
  </mat-dialog-actions>
</div>
